import envConfig from '../config/environment';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LEVELS: Record<LogLevel, number> = { debug: 0, info: 1, warn: 2, error: 3 };

const shouldLog = (level: LogLevel): boolean => {
  if (!envConfig.enableLogging) return level === 'error';
  return LEVELS[level] >= LEVELS[envConfig.logLevel];
};

export const logger = {
  debug: (...args: unknown[]) => { if (shouldLog('debug')) console.debug(...args); },
  info:  (...args: unknown[]) => { if (shouldLog('info'))  console.info(...args); },
  log:   (...args: unknown[]) => { if (shouldLog('info'))  console.log(...args); },
  warn:  (...args: unknown[]) => { if (shouldLog('warn'))  console.warn(...args); },
  error: (...args: unknown[]) => { if (shouldLog('error')) console.error(...args); },
};

export default logger;
